<template>
  <div class="payments">
    <v-row>
      <v-col cols="12" md="3">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9">
        <h1 class="mb-3">گزارش عملکرد</h1>
        <v-card class="pa-8">
          <div class="d-flex align-center">
            <p class="font-weight-bold flex-fill">با سلام</p>
            <p>
              <persian-date :date="date" />
            </p>
          </div>
          <p class="mb-5">
            تا کنون در شهر های تحت پوشش شما
            <strong>{{ usersCount }}</strong> نفر در سامانه ثبت نام کرده و تا به
            حال <strong>{{ sumOfRegularPaymentsCount }}</strong> خرید انجام داده
            اند که جمع خرید آنها
            <strong>{{ sumOfRegularPayments }}</strong> تومان می باشد.
          </p>

          <h5 class="mb-3">لیست شهرهای تحت پوشش شما</h5>
          <div class="gray">
            <v-chip
              v-for="city in cities"
              :key="city._id"
              class="ml-2 mb-2"
              color="gray"
              label
            >
              {{ city.name }}
            </v-chip>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "supervisor-users-component",
  components: {
    NavigationComponent
  },
  data() {
    return {
      loading: true,
      cities: [],
      usersCount: 0,
      sumOfRegularPayments: 0,
      sumOfRegularPaymentsCount: 0,
      date: new Date()
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get("/supervisor/countPayments").then((res) => {
        this.cities = res.data.cities;
        this.usersCount = res.data.usersCount;
        this.sumOfRegularPayments = res.data.sumOfRegularPayments[0].sum;
        this.sumOfRegularPaymentsCount = res.data.sumOfRegularPayments[0].count;
      });
      this.loading = false;
    }
  }
};
</script>
